import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";

// Page imports
import AssessmentWelcome from "pages/assessment-welcome-introduction";
import AssessmentResultsRecommendations from "pages/assessment-results-recommendations";
import MultiStepAssessmentForm from "pages/multi-step-assessment-form";
import NotFound from "pages/NotFound";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          <Route path="/" element={<AssessmentWelcome />} />
          <Route path="/assessment-welcome-introduction" element={<AssessmentWelcome />} />
          <Route path="/assessment-results-recommendations" element={<AssessmentResultsRecommendations />} />
          <Route path="/multi-step-assessment-form" element={<MultiStepAssessmentForm />} />
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;